module.exports = __webpack_public_path__ + "img/icb-co-novice-m@2x.a025fb0d.png";